export default {"src":"/_next/static/media/feature-icon1-3.870c508b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};